import { useGraphQLQuery } from '@betterment/js-runtime';
import { ErrorBoundary } from '@betterment/shared-components';
import { NavLink } from 'react-router-dom';

import {
  ProductOnboardingOptionsDocument,
  ProductOnboardingOptionsQuery,
} from './graphql/query.productOnboardingOptions.generated';

import { addAccountUrl } from '../../../Shared/addAccountUrl';
import { Nav } from '../../../Shared/components-v2/nav/nav';
import { navItemStyles } from '../../../Shared/components-v2/nav/nav-link-styles';
import { urlBuilder } from '../../../Shared/urlBuilder';
import { useProcessNavTransition } from '../../hooks/useProcessNavTransition';
import { ListShimmer } from '../ListShimmer';

type ProductOnboardingOption = ProductOnboardingOptionsQuery['productOnboardingOptions'][number];

const OnboardingOptionNavLinksView: React.FC = () => {
  const processNavTransition = useProcessNavTransition();
  const { data } = useGraphQLQuery(ProductOnboardingOptionsDocument, {
    fetchPolicy: 'cache-first',
  });

  if (!data) return <ListShimmer />;
  if (!data.productOnboardingOptions) return null;

  const { productOnboardingOptions, envelopes } = data;

  return productOnboardingOptions.map((option: ProductOnboardingOption) => {
    if (option.__typename === 'PremiumOnboardingOption') {
      return null;
    }

    const href =
      option.__typename === 'Solo401kOnboardingOption'
        ? urlBuilder.appAdviceInitiationFlow({
            signup_intent: option.legacyProductCategory,
            product_category: option.legacyProductCategory,
          })
        : addAccountUrl({ product_category: option.legacyProductCategory }, false);

    if (option.isInProgress && envelopes.length === 0) {
      return (
        <NavLink
          key={option.id}
          to={href}
          data-turbolinks="false"
          reloadDocument={true}
          onClick={processNavTransition}
          className={navItemStyles()}
        >
          <Nav.Icon asChild={true}>
            <img src={option.image.light} alt="" />
          </Nav.Icon>
          <Nav.Text>{option.name}</Nav.Text>
        </NavLink>
      );
    }

    return null;
  });
};

export const OnboardingOptionNavLinks = () => {
  return (
    <ErrorBoundary fallbackType="inline" feature="sidebar" owner="user_engagement">
      <OnboardingOptionNavLinksView />
    </ErrorBoundary>
  );
};
